"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/universe-ui/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';

var ImageOptimize = function ImageOptimize(props) {
  var className = props.className,
    style = props.style,
    _props$tips = props.tips,
    tips = _props$tips === void 0 ? ['原图', '处理后'] : _props$tips,
    imgList = props.imgList;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom__status"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom__container",
    "data-label": "\u8BF7\u5148\u4E0A\u4F20\u4EBA\u7269\u56FE\u50CF"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom__image"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom-image-board-wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom-image-board-1  cur"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "ai-demo-showroom-image-board-tips"
  }, tips[0]), /*#__PURE__*/_react.default.createElement("img", {
    className: "ai-demo-showroom-image-board-img",
    src: imgList[0],
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-showroom-image-board-3"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "ai-demo-showroom-image-board-tips"
  }, tips[1]), /*#__PURE__*/_react.default.createElement("img", {
    className: "ai-demo-showroom-image-board-img",
    alt: "",
    src: imgList[1]
  })))))));
};
ImageOptimize.defaultProps = {
  content: '测试内容'
};
var _default = exports.default = ImageOptimize;